export default "__VITE_ASSET__369c6a48__"